import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { activateVersion, listVersions, saveVersion } from './api';

export const instructionKeys = { versions: ['agent-prompts', 'simon', 'instruction'] as const };

export function useVersions() {
  return useQuery({ queryKey: instructionKeys.versions, queryFn: ({ signal }) => listVersions(signal) });
}

export function useSaveVersion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: saveVersion,
    onSuccess: () => qc.invalidateQueries({ queryKey: instructionKeys.versions }),
  });
}

export function useActivateVersion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: activateVersion,
    onSuccess: () => qc.invalidateQueries({ queryKey: instructionKeys.versions }),
  });
}
